import FirebaseAnalytics from '@shamrock-core/common/analytics/firebase-analytics';
import AppStore from '../redux/configureStore';
const Config = require('Config');

export const removeQuery = (...queryNames) => {
  const queryString = require('query-string');
  const params = queryString.parse(location.search);
  queryNames.forEach((q) => delete params[q]);
  const newParams = Object.keys(params).length === 0 ? '' : `?${queryString.stringify(params)}`;
  window.history.pushState({}, document.title, (location.pathname || '/') + newParams);
};

export function sortAlphabetically(a, b) {
  let textA;
  let textB;
  try {
    textA = a.toUpperCase();
  } catch (e) {
    textA = 'undefined';
  }
  try {
    textB = b.toUpperCase();
  } catch (e) {
    textB = 'undefined';
  }
  return textA < textB ? -1 : textA > textB ? 1 : 0;
}

export const getDeviceType = () => {
  // Not super reliable but works for most scenarios
  const ua = navigator.userAgent;
  if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
    return 'Tablet';
  }
  if (/Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
    return 'Mobile';
  }
  return 'Desktop';
};

export const logClick = (label) => {
  const { width, height } = window.screen;
  FirebaseAnalytics.sendEvent(
    FirebaseAnalytics.EVENTS.CLICK,
    FirebaseAnalytics.MODULES.RTSPRO,
    'GLOBAL_NOTIFICATION_DIALOG',
    {
      label,
      resolution: `${width}X${height}`,
      browserType: getDeviceType(),
    },
  );
};

export const getIsTrial = (token?: string) => {
  return AppStore.getState().app.user?.userStatus?.isTrial || token === 'trialToken';
};

export const isBeingAddedField = (localField: string, storeField: string) =>
  storeField?.length === 0 && localField?.length > 0;

export const isBeingEditedField = (localField: string, storeField: string) =>
  storeField?.length > 0 && localField?.length > 0 && storeField !== localField;

export const padDateString = (value: number) => ('0' + value.toString()).slice(-2);

export const redirectToLogout = () => {
  window.location.href = `${Config.rtsproHomepage}logout`;
};

export const redirectToV2Logout = () => {
  window.location.href = `${Config.rtsproHomepage}v2/logout`;
};

/**
 * This function applies a timeout on a async function's execution
 * @param {function} func
 * @param {number} delay
 * @return {*}
 */
export function debounceAsync(func, delay) {
  let timer = null;

  return (...args) => {
    clearTimeout(timer);
    return new Promise((resolve) => {
      timer = setTimeout(() => resolve(func(...args)), delay);
    });
  };
}

//Use when hooks cannot be leveraged
export function isFeatureEnabled(feature: string): boolean {
  return AppStore.getState().app.features.includes(feature);
}

export enum FF {
  AUTH0 = '43e3edab1c8c8e0366d34b17feeb203427cb10ae23e0a592b6be61d0b4aa8afd',
  BANKING = '221873e5ad8d84e410de49c87a8b6451265b936f0b8dff83f0d58d8eefd409c3',
}

export enum AUTH0_ERRORS {
  USER_BLOCKED = 'user is blocked',
}
